/**
 * Xero Missing Closure COGS Bills Report
 *
 * Identifies register closure dates where Closure COGS Bills are missing in Xero.
 * One row per contact+date combo, with links to Closure Sales Invoices and COGS Bills.
 */
import BaseReportPage, { ColumnDef } from './BaseReportPage'

const columns: ColumnDef[] = [
  { key: 'fp_code', label: 'FP Code' },
  { key: 'franchise_name', label: 'Franchise' },
  { key: 'last_sync_at', label: 'Data Age', type: 'sync_status' },
  { key: 'fp_status', label: 'Status' },
  { key: 'closure_date', label: 'Closure Date', type: 'date' },
  { key: 'updated_date_utc', label: 'Updated (UTC)', type: 'datetime' },
  { key: 'register_name', label: 'LS Register', link: { field: 'register_closure_link', system: 'lightspeed' } },
  { key: 'contact_name', label: 'Xero Contact', link: { field: 'xero_contact_link', system: 'xero' } },
  { key: 'sales_invoice_count', label: 'Sales Inv.', type: 'integer' },
  { key: 'cogs_bill_count', label: 'COGS Bills', type: 'integer' },
  { key: 'missing_count', label: 'Missing', type: 'integer' },
  { key: 'sales_invoice_total', label: 'Sales Inv. Total', type: 'currency' },
  { key: 'sales_invoice_numbers', label: 'Sales Inv. #', link: { field: 'first_sales_invoice_link', system: 'xero' } },
  { key: 'cogs_bill_numbers', label: 'COGS Bill #', link: { field: 'first_cogs_bill_link', system: 'xero' } },
]

export default function XeroMissingClosureCogsBillsReport() {
  return (
    <BaseReportPage
      reportType="xero_missing_closure_cogs_bills"
      title="Xero Missing Closure COGS Bills"
      description="Identify register closure dates where Closure COGS Bills are missing in Xero."
      filterConfig={{
        showFpSelector: true,
        showFpStatus: true,
        showCountry: true,
        showRegion: true,
        showDateRange: true,
        defaultDateRange: 'last_30_days',
        linkFpStatusToSearch: true,
      }}
      columns={columns}
      defaultSortColumn="closure_date"
      defaultSortDirection="desc"
    />
  )
}
